// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__36kSG","bigColWidth":"Table_bigColWidth__3a2-0","biggerColWidth":"Table_biggerColWidth__R23sc","row":"Table_row__1fYus","col":"Table_col__1b-G1"};